<template>
  <Transition name="fade-page" mode="out-in">
    <BaseLoader v-if="loading.pergunta" />

    <template v-else-if="!loading.pergunta && pergunta?.id">
      <section class="mb-48">
        <HeaderPagePergunta
          :title="pergunta.pergunta"
          :description="pergunta.descricao"
          :pergunta
          :assessment
          :fabricante="model.fabricante"
          @click:open-evidencias="onClickButtonEvidencia"
          @click:open-plano-acao="onOpenModalPlanoAcao"
          @click:open-acompanhamento="onOpenModalAcompanhamento"
          @click:open-editar-campos="onOpenModalEditarCampos"
          @update:fabricante="(v) => (model.fabricante = v)"
        />

        <QCard
          :flat="true"
          class="block bg-card-primary border overflow-hidden border-neutral-100/10 rounded-lg mt-32 mb-16"
        >
          <TabPergunta
            v-if="assessment.show_periods"
            :tipo-opcao
            @click:periods="onClickPeriods"
            @click:current="onClickCurrent"
            @click:view="onClickView"
          />
          <ToggleView
            v-else-if="tipoOpcao.tradicional"
            class="px-24 pt-24"
            @click:view="onClickView"
          />
          <template
            v-if="
              alternativas.length &&
                visualizacao === 'column' &&
                tipoOpcao.tradicional
            "
          >
            <AlternativasVertical
              :tipo-opcao
              :alternativas
              :respostas
              :assessment
              @click:evidencia="onClickEvidencia"
              @click:opt="onClickButton"
              @update:opt="onUpdateOpt"
            />
          </template>
          <template
            v-else-if="alternativas.length && visualizacao === 'row'"
          >
            <AlternativasHeader
              ref="headerRef"
              :alternativas
              :tipo-opcao
            />
            <section class="flex flex-nowrap">
              <Alternativas
                :tipo-opcao
                :alternativas
                :respostas
                :assessment
                @click:evidencia="onClickEvidencia"
              />
              <AlternativaOpcaoButton
                v-if="tipoOpcao.tradicional"
                :alternativas
                :respostas
                :height-alternativa
                @click:opt="onClickButton"
              />
              <AlternativaOpcaoCheckbox
                v-else-if="tipoOpcao.checkbox"
                :alternativas
                :respostas
                :height-alternativa
                @click:opt="onClickButton"
              />
              <AlternativaOpcaoSimNao
                v-else-if="tipoOpcao.sim_nao_livre"
                :alternativas
                :respostas
                :height-alternativa
                @update:opt="onUpdateOpt"
              />
            </section>
          </template>
        </QCard>

        <footer
          v-if="pergunta?.proxima_pergunta"
          class="flex justify-end"
        >
          <OButton
            secondary
            size="md"
            class="group"
            @click="
              () =>
                $router.push({
                  name: 'pergunta',
                  params: { id: pergunta.proxima_pergunta },
                })
            "
          >
            <span
              class="!font-semibold translate-x-8 group-hover:-translate-x-0 transition-transform duration-300"
            >
              {{ t('next') }}
            </span>
            <q-icon
              name="chevron_right"
              class="opacity-0 group-hover:opacity-100 transition-transform duration-300 w-10 -translate-x-2"
            />
          </OButton>
        </footer>
      </section>
    </template>
    <EmptyItem v-else />
  </Transition>

  <ModalEvidenciaCreate
    v-if="pergunta?.id"
    ref="modalEvidenciaCreateRef"
    @click:save="onSaveEvidencia"
  />
  <ModalEvidencia
    v-if="pergunta?.id"
    ref="modalEvidenciaRef"
    :loading="loadingEvidencia"
    @click:aprovar="onClickAprovarReprovar($event, true)"
    @click:reprovar="onClickAprovarReprovar($event)"
    @click:editar="onClickEditar"
  />
  <ModalPlanoAcao
    v-if="pergunta?.id"
    ref="modalPlanoAcaoRef"
    :pergunta="$route.params.id"
    :alternativas
    @submit="sendPlanoAcao"
    @update="updatePlanoAcao"
  />
  <ModalAcompanhamento
    v-if="pergunta?.id"
    ref="modalAcompanhamentoRef"
    :alternativas
    :pergunta
    @submit="sendAcompanhamento"
  />
  <ModalEditarCampos
    v-if="pergunta?.id"
    ref="modalEditarCamposRef"
    :pergunta
    :alternativas
    :loading="loading.edit"
    @submit="sendPerguntaEdit"
  />
  <Transition name="fade">
    <q-page-sticky
      v-if="loading.enviandoResposta"
      position="bottom-left"
      :offset="[80, 18]"
      class="z-[99999999]"
    >
      <div
        class="flex items-center text-headline-3 px-10 gap-8 py-6 bg-white rounded-3xl shadow-xl min-h-40"
      >
        <BaseLoader size="24px" /> {{ t('sending') }}
      </div>
    </q-page-sticky>
  </Transition>
</template>

<script setup>
import { onMounted, provide, watch } from 'vue'
import { useEvidencia } from 'composables/useEvidencia'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import AlternativaOpcaoButton from 'components/Alternativa/AlternativaOpcaoButton.vue'
import AlternativaOpcaoCheckbox from 'components/Alternativa/AlternativaOpcaoCheckbox.vue'
import AlternativaOpcaoSimNao from 'components/Alternativa/AlternativaOpcaoSimNao.vue'
import Alternativas from 'components/Alternativa/Alternativas.vue'
import AlternativasHeader from 'components/Alternativa/AlternativasHeader.vue'
import AlternativasVertical from 'components/Alternativa/AlternativasVertical.vue'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import EmptyItem from 'components/Empty/EmptyItem.vue'
import HeaderPagePergunta from 'components/Header/HeaderPagePergunta.vue'
import ModalAcompanhamento from 'components/Modal/ModalAcompanhamento.vue'
import ModalEditarCampos from 'components/Modal/ModalEditarCampos.vue'
import ModalEvidencia from 'components/Modal/ModalEvidencia.vue'
import ModalEvidenciaCreate from 'components/Modal/ModalEvidenciaCreate.vue'
import ModalPlanoAcao from 'components/Modal/ModalPlanoAcao.vue'
import OButton from 'components/Button/OButton.vue'
import TabPergunta from 'components/Tabs/TabPergunta.vue'
import ToggleView from 'components/PagePergunta/ToggleView.vue'
import useAssessment from 'composables/useAssessment'
import usePerguntas from 'composables/usePerguntas'

const { t } = useI18n()
const route = useRoute()

const {
  updatePlanoAcao,
  tipoOpcao,
  sendPlanoAcao,
  sendAcompanhamento,
  sendPerguntaEdit,
  respostas,
  pergunta,
  onUpdateOpt,
  onOpenModalPlanoAcao,
  onOpenModalAcompanhamento,
  onOpenModalEditarCampos,
  onClickButtonEvidencia,
  onClickEvidencia,
  onClickButton,
  onClickPeriods,
  onClickCurrent,
  onClickView,
  model,
  visualizacao,
  loading,
  initialRequests,
  headerRef,
  alternativas,
  heightAlternativa,
  modalPlanoAcaoRef,
  modalAcompanhamentoRef,
  modalEditarCamposRef,
} = usePerguntas()

const {
  onSaveEvidencia,
  modalEvidenciaRef,
  modalEvidenciaCreateRef,
  onClickAprovarReprovar,
  onClickEditar,
  loading: loadingEvidencia,
} = useEvidencia()

const { assessment } = useAssessment()

watch(
  () => route.params.id,
  (v) => initialRequests(v)
)

onMounted(() => {
  initialRequests(route.params.id)
})

provide('headerRef', headerRef)
</script>

<style lang="sass">
@import '../../../css/responsivo.sass'
:root
  --opcoes-width: 200px
  --opcoes-height: 90px
  --pergunta-width: 1020px
  --pergunta-height: 110px

  @include d(lg)
    --pergunta-width: 750px

.isCheckbox
  --pergunta-width: 100%
  max-width: calc(100% - 200px)

.grid-cols-opcoes
  grid-auto-flow: column
  display: grid
  grid-auto-columns: minmax(200px, 100%)

.grid-rows-opcoes
  grid-auto-flow: row
  display: grid
  grid-auto-columns: minmax(200px, 100%)
</style>
